module.exports = __webpack_public_path__ + "media/001.02db112b.mp3";